function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 3,
  cy: 10,
  r: 3,
  transform: "translate(0 -7)",
  fill: "#528BFD",
  fillRule: "evenodd"
});

var SvgOval = function SvgOval(props) {
  return React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6"
  }, props), _ref);
};

export default "data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='6px' height='6px' viewBox='0 0 6 6' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cg transform='translate(-28.000000, -486.000000)' fill='%23528BFD'%3E %3Cg transform='translate(28.000000, 301.000000)'%3E %3Cg transform='translate(0.000000, 178.000000)'%3E %3Cg%3E %3Cg%3E %3Ccircle cx='3' cy='10' r='3'%3E%3C/circle%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E";
export { SvgOval as ReactComponent };